import { useInvoice } from '@melio/ar-domain';
import { useAnalyticsContext, withAnalyticsContext } from '@melio/platform-analytics';
import { forwardRef, useDateUtils } from '@melio/platform-utils';
import { useMemo } from 'react';

import { MarkAsPaidFormField } from '../../components';
import { MarkInvoiceAsPaidScreen } from './screens';

type MarkInvoiceAsPaidActivityProps = {
  onClose: VoidFunction;
  onDone: VoidFunction;
  isOpen: boolean;
  onError?: ErrorFunction;
  invoiceId: string;
};

export const MarkInvoiceAsPaidInnerActivity = forwardRef<MarkInvoiceAsPaidActivityProps>(
  ({ onClose, onDone, onError, isOpen, invoiceId, ...props }, ref) => {
    const { data: invoice, isFetching, isMutating, markAsPaid } = useInvoice({ id: invoiceId, enabled: false });

    const { createDate } = useDateUtils();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const currentDate = useMemo(() => createDate(), []);

    useAnalyticsContext({ globalProperties: { InvoiceId: invoice?.id } });
    const handleSubmit = ({ paymentDate, paymentMethod, note, referenceNumber }: MarkAsPaidFormField) => {
      markAsPaid({
        paidAt: paymentDate,
        method: paymentMethod ? paymentMethod : undefined,
        note,
        referenceNumber,
      })
        .then(onDone)
        .catch(onError);
    };

    return (
      <MarkInvoiceAsPaidScreen
        onClose={onClose}
        onSubmit={handleSubmit}
        isOpen={isOpen}
        isLoading={isFetching}
        isSaving={isMutating}
        amount={invoice?.totalAmount || 0}
        paymentDate={currentDate}
        ref={ref}
        {...props}
      />
    );
  }
);

export const MarkInvoiceAsPaidActivity = withAnalyticsContext(MarkInvoiceAsPaidInnerActivity);
